import { IBoondockRating, IGuestRating, IListingRating, IPoiRating } from '@curbnturf/entities';
import { createReducer, on } from '@ngrx/store';
import * as RatingActions from './rating.actions';

export interface RatingState {
  listingRatings: { [syncId: string]: IListingRating };
  guestRatings: { [syncId: string]: IGuestRating };
  boondockRatings: { [syncId: string]: IBoondockRating };
  poiRatings: { [syncId: string]: IPoiRating };
  caretakerSites: number[]; // List of sites that have been selected for caretaking.
  loaded: boolean; // has the Rating list been loaded
  error?: string; // last error (if any)
}

export const initialState: RatingState = {
  listingRatings: {},
  guestRatings: {},
  boondockRatings: {},
  poiRatings: {},
  caretakerSites: [],
  loaded: false,
};

export const ratingReducer = createReducer(
  initialState,
  on(RatingActions.listingRatingsLoaded, (state, { ratings }) => {
    const updatedRatingIds = ratings.map((updatedRating) => updatedRating.id);
    const newRatings: { [syncId: string]: IListingRating } = {};
    updatedRatingIds.forEach((ratingId, index) => {
      if (ratingId) {
        newRatings[ratingId] = ratings[index];
      }
    });

    return {
      ...state,
      listingRatings: { ...state.listingRatings, ...newRatings },
      loaded: true,
    };
  }),
  on(RatingActions.syncListingRatings, (state, { response }) => {
    const listingRatings = { ...state.listingRatings };
    response?.forEach((el) => {
      if (el.syncId) {
        listingRatings[el.syncId] = el;
      }
    });
    return {
      ...state,
      listingRatings,
    };
  }),
  on(RatingActions.guestRatingsLoaded, (state, { ratings }) => {
    const updatedRatingIds = ratings.map((updatedRating) => updatedRating.id);
    const newRatings: { [syncId: string]: IGuestRating } = {};
    updatedRatingIds.forEach((ratingId, index) => {
      if (ratingId) {
        newRatings[ratingId] = ratings[index];
      }
    });

    return {
      ...state,
      guestRatings: { ...state.guestRatings, ...newRatings },
      loaded: true,
    };
  }),
  on(RatingActions.syncGuestRatings, (state, { response }) => {
    const guestRatings = { ...state.guestRatings };
    response?.forEach((el) => {
      if (el.syncId) {
        guestRatings[el.syncId] = el;
      }
    });
    return {
      ...state,
      guestRatings,
    };
  }),
  on(RatingActions.boondockRatingsLoaded, (state, { ratings }) => {
    const updatedRatingIds = ratings.map((updatedRating) => updatedRating.id);
    const newRatings: { [syncId: string]: IBoondockRating } = {};
    updatedRatingIds.forEach((ratingId, index) => {
      if (ratingId) {
        newRatings[ratingId] = ratings[index];
      }
    });

    return {
      ...state,
      boondockRatings: { ...state.boondockRatings, ...newRatings },
      loaded: true,
    };
  }),
  on(RatingActions.poiRatingsLoaded, (state, { ratings }) => {
    const updatedRatingIds = ratings.map((updatedRating) => updatedRating.id);
    const newRatings: { [syncId: string]: IPoiRating } = {};
    updatedRatingIds.forEach((ratingId, index) => {
      if (ratingId) {
        newRatings[ratingId] = ratings[index];
      }
    });

    return {
      ...state,
      poiRatings: { ...state.poiRatings, ...newRatings },
      loaded: true,
    };
  }),
  on(RatingActions.selectCaretakerBoondock, (state, { caretaker }) => {
    const boondockId = caretaker.boondockId;
    if (boondockId && !state.caretakerSites.includes(boondockId)) {
      const caretakerSites = [...state.caretakerSites];
      caretakerSites.push(boondockId);
      return {
        ...state,
        caretakerSites,
      };
    }
    return state;
  }),
);
